import * as ACTION_TYPES from '@stores/actions/action_types'

export interface LayoutsStateType {
  layout: {
    layout_type: object
  }
  layout_types: A
  error: A
  new_layout: {
    theme: object
  }
}
export const initialState = {
  layout: {
    layout_type: {},
  },
  layout_types: [],
  error: [],
  new_layout: {
    theme: {},
  },
}
const LayoutsReducer = (state: LayoutsStateType, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.GET_LAYOUTS:
      return {
        ...state,
        layout: action.layout,
        layout_types: action.layout_types,
      }
    case ACTION_TYPES.UPDATE_LAYOUTS_SUCCESS:
      return {
        ...state,
        ...action.data,
      }
    case ACTION_TYPES.CHOOSE_LAYOUT:
      return {
        ...state,
        new_layout: { ...state.new_layout, ...action.new_layout },
      }
    case ACTION_TYPES.CREATE_LAYOUT_SUCCESSFUL:
      return {
        ...state,
        new_layout: { theme: {} },
      }
    default:
      return state
  }
}
export default LayoutsReducer
